"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidationFormat = void 0;
var ValidationFormat = {
  Email: "Email",
  PhoneNumber: "Phone Number",
  ZipCode: "Zip Code",
  Currency: "Currency",
  Number: "Number"
};
exports.ValidationFormat = ValidationFormat;